import React, { ReactNode, useMemo } from 'react'

import { Layout } from 'react-grid-layout'

import { useMediaQuery, useTheme } from '@mui/material'

import { TCustomization } from 'types/GlobalCustomization'

import Mobile from './mobile'
import Desktop from './desktop'
import { DashboardVariant } from 'types/GlobalDashboard'

interface DashboardGridProps {
  children: (props: { scaleFactor: number }) => ReactNode
  customization?: TCustomization
  layout: Layout[]
  title: string
  updateLayout: (layout: Layout[]) => void
  variant: DashboardVariant
}

const DashboardGrid = (props: DashboardGridProps) => {
  const { customization, children, layout, title, updateLayout, variant } =
    props

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('mobile'), {
    noSsr: true
  })

  const component = useMemo(
    () =>
      isMobile ? (
        <Mobile customization={customization}>{children}</Mobile>
      ) : (
        <Desktop
          customization={customization}
          layout={layout}
          title={title}
          updateLayout={updateLayout}
          variant={variant}
        >
          {children}
        </Desktop>
      ),
    [isMobile, customization, layout, title, variant, children]
  )

  return component
}

export default DashboardGrid

// https://github.com/react-grid-layout/react-grid-layout/issues/1104
